import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppAll from './AppAll';
import AppBook from './AppBook';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('lit-cmp-blog'));
var date = new Date();
    // if((date.getFullYear() == 2023) && ((date.getMonth()+1) == 3) && (date.getDate() < 19)){

      var id = document.getElementById("lit-cmp-blog-next")
      var dalsiAds = "NA0"; 

      root.render(
        <React.StrictMode>
          <AppAll dalsi = {dalsiAds}/>
        </React.StrictMode>
      );
        if(id == '[object HTMLDivElement]')
      {
        const next = ReactDOM.createRoot(id);
        dalsiAds = "NA1";
        next.render(
          <React.StrictMode>
            <AppAll dalsi = {dalsiAds} />
          </React.StrictMode>
        );
      } else {
        dalsiAds = "NA0";
      }

    // } else {
    //   root.render(
    //     <React.StrictMode>
    //       <App />
    //     </React.StrictMode>
    //   );
    // }
var idBook = document.getElementById("lit-cmp-blog-book")
if (idBook == '[object HTMLDivElement]') {
  const book = ReactDOM.createRoot(idBook);
        book.render(
          <React.StrictMode>
            <AppBook />
          </React.StrictMode>
        );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
